import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import styles from '../../../styles';
import { FooterLink, DateView } from '../../common';
import { useResult } from '../../../hooks';
import { getDisplaydate } from '../../../utils/date-utils';
import { withLocal } from '../../common/LocaleProvider/LocaleProvider';
import risk from '../../../constants/risk';
import routes from '../../../constants/routes';

const useStyles = makeStyles({
  root: {
    ...styles.statusPageRoot,
    padding: '38px 16px 16px 16px',
    backgroundColor: '#ac0145'
  },
  list: {
    paddingLeft: '24px',
    '& > li': {
      marginBottom: '16px'
    }
  },
  error: {
    ...styles.error,
    marginTop: '8px',
    textAlign: 'center',
    color: '#fff'
  }
});

//DISPO 1
const HighRisk = ({ history, locale }) => {
  const classes = useStyles();

  const [displayDate, setDisplayDate] = useState({});
  const { result } = useResult();
  const locState = history.location.state;
  const { cat, date, err } = locState || result;

  useEffect(() => {
    if (cat !== risk.HIGH) {
      history.push(routes.HOME_PAGE);
    }
  }, [cat, history]);

  useEffect(() => {
    if (date) {
      setDisplayDate({ ...getDisplaydate(date, locale) });
    }
  }, [date, locale]);

  const getError = () => (err ? `${locale.result.twistle_error} ${err}` : '');

  return (
    <div className={classes.root}>
      <ErrorOutlineIcon style={{ fontSize: '64px' }} />
      <DateView displayDate={displayDate} />
      <span className={classes.error}>{getError()}</span>
      <div>
        <p>
          {locale.result.high_risk_header} {locale.result.next_steps}
        </p>
        <ol className={classes.list}>
          {locale.result.high_risk_steps.map((text, index) => (
            <li key={`step-li-${index}`}>{text}</li>
          ))}
        </ol>
      </div>
      <FooterLink locale={locale} />
    </div>
  );
};

export default withLocal(HighRisk);
